var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { HttpApiV5Request } from "./http-api-request.js";
export function loadCollections(config) {
    return __awaiter(this, void 0, void 0, function* () {
        var _a;
        let response = yield new HttpApiV5Request('collections', config).fetch();
        return ((_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.items) || [];
    });
}
export function createCollection(payload, config) {
    return __awaiter(this, void 0, void 0, function* () {
        let response = yield new HttpApiV5Request('collections', config).setMethod('POST').setPayload(payload).fetch();
        return response.data;
    });
}
export function updateCollection(payload, config) {
    return __awaiter(this, void 0, void 0, function* () {
        let response = yield new HttpApiV5Request('collections', config).setMethod('PUT').setPayload(payload).fetch();
        return response.data;
    });
}
export function deleteCollection(payload, config) {
    return __awaiter(this, void 0, void 0, function* () {
        var _a;
        let response = yield new HttpApiV5Request(`collections/${payload.id}`, config).setMethod('DELETE').fetch();
        return ((_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.items) || [];
    });
}
export function addBooksToCollection(collectionId, payload, config) {
    return __awaiter(this, void 0, void 0, function* () {
        var _a;
        let response = yield new HttpApiV5Request(`collections/${collectionId}/books/add`, config).setMethod('PATCH').setPayload(payload).fetch();
        return ((_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.items) || [];
    });
}
export function removeBooksFromCollection(collectionId, payload, config) {
    return __awaiter(this, void 0, void 0, function* () {
        var _a;
        let response = yield new HttpApiV5Request(`collections/${collectionId}/books/remove`, config).setMethod('PATCH').setPayload(payload).fetch();
        return ((_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.items) || [];
    });
}
//# sourceMappingURL=collection-service.js.map